module.exports = __webpack_public_path__ + "assets/img/Arty_003.a786c703-ps.jpg";